import styles from "../assets/css/HOC/myAccount.module.css";
export const MyAccount = (Component) => () => {
  return (
    <div className={styles.myAccount}>
      <Component />
    </div>
  );
};
